<template>
  <StepLayout
    title="知りたいことを選んでください"
    :current-step="1"
    @back="handleBack"
  >
    <OptionList
      v-model="model"
      :options="categoryOptions"
      aria-label="知りたいことの選択"
      @select="handleSelect"
    />

    <template #footer>
      <SkipLink label="この質問をスキップする" @click="handleSkip" />
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import StepLayout from './StepLayout.vue';
import OptionList from './OptionList.vue';
import SkipLink from './SkipLink.vue';
import type { CategoryOption } from '../types';

defineProps<{
  keyword: string;
}>();

const model = defineModel<CategoryOption | null>({ default: null });

const emit = defineEmits<{
  next: [];
  back: [];
  skip: [];
}>();

const categoryOptions = [
  {
    value: 'should_go_hospital',
    label: '病院に行くべき？',
    subtitle: '緊急性・受診目安を知りたい',
  },
  {
    value: 'which_department',
    label: '何科に行けばいい？',
    subtitle: '適切な診療科・場所を知りたい',
  },
  {
    value: 'cause',
    label: '原因は？',
    subtitle: '症状の原因・考えられる病気を知りたい',
  },
  {
    value: 'how_to_deal',
    label: '対処法は？',
    subtitle: '日常生活で気をつけることを知りたい',
  },
  {
    value: 'medicine_treatment',
    label: '薬や治療法は？',
    subtitle: '薬の効果や副作用・飲み合わせを知りたい',
  },
  {
    value: 'other',
    label: 'その他',
    subtitle: 'あてはまるものがない',
  },
];

const handleSelect = () => {
  emit('next');
};

const handleBack = () => {
  emit('back');
};

const handleSkip = () => {
  emit('skip');
};
</script>

<style lang="scss" scoped>
// StepLayout provides all common styling
</style>
